import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, ksaProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { VENDOR_DOWNLOAD_DUMP, VENDOR_DOWNLOAD_DUMP_SUCCESS, VENDOR_DOWNLOAD_DUMP_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* vendorDownloadDump({ payload }) {
  const headers = payload?.headers?.code
    ? { Authorization: Constant?.CLIENT_TOKEN, 'Content-Type': 'application/json', 'Project-Code': payload?.headers?.code }
    : { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders };

  const platformHeader = Constant.PROJECT_CODE === 'SAB' ? { 'x-platform': 'gcp' } : {};

  try {
    const response = yield call(apiCall, {
      url: `${Constant.PROJECT_CODE === 'SAB' ? ksaProjectsBaseURL : uaeProjectsBaseURL}/vendor/downloads`,
      method: 'POST',
      headers: {
        ...headers,
        ...platformHeader,
      },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: VENDOR_DOWNLOAD_DUMP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: VENDOR_DOWNLOAD_DUMP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VENDOR_DOWNLOAD_DUMP_ERROR, payload: error });
  }
}

export function* watchVendorDownloadDump() {
  yield takeEvery(VENDOR_DOWNLOAD_DUMP, vendorDownloadDump);
}

function* vendorDownloadDumpSaga() {
  yield all([fork(watchVendorDownloadDump)]);
}

export default vendorDownloadDumpSaga;
